module.exports = __webpack_public_path__ + "static/sample-5-7c0db725de8bf5a1ea11db573a97d312.png";